<template>
  <div class="apps-page" v-loading="pageLoading">
    <div class="apps-page__top">
      <div class="apps-page__title">Apps</div>
      <el-button type="success" :icon="Plus" @click="modalVisible = true">
        Create App
      </el-button>
    </div>
    <div class="apps-page__main">
      <div class="apps-page__content">
        <el-table
          :data="list"
          height="100%"
          style="width: 100%; border-radius: 4px"
        >
          <template #empty>
            <EmptyData class="apps-page__table-empty" />
          </template>
          <el-table-column prop="id" label="#" width="70">
            <template #default="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="Title" />
          <el-table-column prop="bundle" label="Bundle" />
        </el-table>
      </div>
    </div>

    <CreateAppModal
      v-model="modalVisible"
      :loading="submitLoading"
      @submit="handleCreate"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { Plus } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { EmptyData } from "@/shared/ui/components/EmptyData";
import { IApplication } from "@/shared/types/applications";
import CreateAppModal from "./CreateAppModal.vue";

const store = useStore();

const modalVisible = ref(false);
const pageLoading = ref(false);
const submitLoading = ref(false);

const list = computed<IApplication[]>(() => store.state.applications.list);

onMounted(async () => {
  pageLoading.value = true;
  await store.dispatch("applications/getApplications");
  pageLoading.value = false;
});

const handleCreate = async (payload: { title: string; bundle: string }) => {
  submitLoading.value = true;
  try {
    const response = await store.dispatch(
      "applications/createApplication",
      payload
    );
    if (response) {
      ElMessage({ message: "App created successfully", type: "success" });
      modalVisible.value = false;
      await store.dispatch("applications/getApplications");
    }
  } finally {
    submitLoading.value = false;
  }
};
</script>

<style lang="scss">
.apps-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 24px;
    height: 56px;
    flex-shrink: 0;
    margin-bottom: 16px;
  }
  &__title {
    font-size: 18px;
    font-weight: 800;
    line-height: 26px;
  }
  &__main {
    display: flex;
    height: 100%;
    overflow: hidden;
    padding-right: 24px;
  }
  &__content {
    flex-grow: 1;
    height: 100%;
    width: 100%;
    border-radius: var(--Radius-border-radius-base, 4px);
    background: var(--Color-Background-bg-color, #fff);
  }
  &__table-empty {
    margin: 0 auto;
  }
}
</style>
